"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoSuggestItem = _interopRequireDefault(require("./AutoSuggestItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class AutoSuggestList extends _react.PureComponent {
  static defaultProps = {
    hidden: true,
    suggestions: [],
    isCustomSuggestions: false
  };
  _onSuggestionSelect = suggestion => {
    this.props.onSuggestionSelect({
      suggestion
    });
  };
  render() {
    const {
      hidden,
      suggestions,
      activeSuggestion,
      suggestionBoxFooter,
      onSuggestionMouseDown,
      onSuggestionMouseOut,
      forwardRef,
      additionalSuggestionsTitle,
      additionalSuggestions,
      searchSuggestionsTitle,
      isCustomSuggestions
    } = this.props;
    const classes = (0, _classnames.default)('AutoSuggestInput-suggestions', {
      'AutoSuggestInput-suggestions-hidden': hidden
    });

    // Nice to have - if Airport suggestions are treated as custom suggestions.
    // This is not implemented now as all this will be discarded in new home page.
    const googleSuggestions = isCustomSuggestions ? suggestions : suggestions?.filter(suggestion => suggestion?.place_id);
    const headingClasses = (0, _classnames.default)('AutoSuggestInput-heading');
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: classes,
      ref: forwardRef
    }, Boolean(googleSuggestions?.length) && /*#__PURE__*/_react.default.createElement("p", {
      className: headingClasses,
      "data-testid": "Search-suggestions-title"
    }, searchSuggestionsTitle), googleSuggestions.map(suggestion => {
      const {
        id,
        className
      } = suggestion;
      const active = activeSuggestion && id === activeSuggestion.id;
      return /*#__PURE__*/_react.default.createElement(_AutoSuggestItem.default, {
        key: id,
        className: className,
        suggestion: suggestion,
        active: active,
        onSuggestionSelect: this._onSuggestionSelect,
        onSuggestionMouseDown: onSuggestionMouseDown,
        onSuggestionMouseOut: onSuggestionMouseOut
      });
    }), Boolean(additionalSuggestions?.length) && /*#__PURE__*/_react.default.createElement("p", {
      className: headingClasses,
      "data-testid": "Search-additional-suggestions-title"
    }, additionalSuggestionsTitle), additionalSuggestions?.map(suggestion => {
      const {
        id,
        className
      } = suggestion;
      const active = activeSuggestion && id === activeSuggestion.id;
      return /*#__PURE__*/_react.default.createElement(_AutoSuggestItem.default, {
        key: id,
        className: className,
        suggestion: suggestion,
        active: active,
        onSuggestionSelect: this._onSuggestionSelect,
        onSuggestionMouseDown: onSuggestionMouseDown,
        onSuggestionMouseOut: onSuggestionMouseOut
      });
    }), Boolean(googleSuggestions?.length) && suggestionBoxFooter);
  }
}
var _default = exports.default = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(AutoSuggestList, (0, _extends2.default)({
  forwardRef: ref
}, props)));